import { Typography } from "src/components/shared";

export const SummitImageAndText = ({ content }: { content: any }) => {
    const imageDesc = content?.imageDescriptionJson?.json?.content?.[0]?.content?.[0]?.value || "";
    
    return (
      <div className="summit-event-title">
        <Typography tag="h3">
          {content?.title}
        </Typography>
        <Typography tag="p" className="grey-medium-dark mx-w-450">
          {imageDesc}
        </Typography>
      </div>
    );
  };